import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { tradingToolsActions } from '../+state/trading-tools.actions';
import { tradingToolsFeature } from '../+state/trading-tools.reducer';
import { selectActiveUnderlying, selectActiveUnderlyingIndex } from '../+state/trading-tools.selectors';
import { UnderlyingSegment } from '../entities/easy-trading-matrix.entity';

@Injectable({ providedIn: 'root' })
export class TradingToolsFacade {
  readonly #store = inject(Store);

  public readonly easyTradingMatrix$ = this.#store.select(tradingToolsFeature.selectEasyTradingMatrix);
  public readonly underlyings$ = this.#store.select(tradingToolsFeature.selectUnderlyings);
  public readonly currentUnderlyingIndex$ = this.#store.select(selectActiveUnderlyingIndex);
  public readonly selectedUnderlyingIsin$ = this.#store.select(tradingToolsFeature.selectActiveUnderlyingIsin);
  public readonly activeUnderlying$ = this.#store.select(selectActiveUnderlying);
  public readonly loadingEasyTradingMatrix$ = this.#store.select(tradingToolsFeature.selectLoadingEasyTradingMatrix);
  public readonly loadingUnderlyings$ = this.#store.select(tradingToolsFeature.selectLoadingUnderlyings);

  public loadEasyTradingMatrix = (isin: string) => this.#store.dispatch(tradingToolsActions.loadEasyTradingMatrix({ isin }));
  public loadUnderlyings = (segment: UnderlyingSegment) => this.#store.dispatch(tradingToolsActions.loadUnderlyings({ segment }));
  public selectUnderlying = (isin: string) => this.#store.dispatch(tradingToolsActions.selectUnderlying({ isin }));
}
